import React from "react";
import { GifPath } from "../../../assets/gifPath";


const FrontmGifLogoLoader = ({restartKey}) => {
    return (
        <div className="bg-white loader-ons w-full h-[82vh] flex items-center justify-center absolute top-0 left-0 z-10 ">
            <img
                key={restartKey}
                className="w-[155px]"
                src={`${GifPath.mainlogo}?v=${restartKey}`}
                alt="Onship || Images(svg, jpg, png)"
            />
        </div>
    )
};

export default FrontmGifLogoLoader

